import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Info, Zap, Database, Globe } from "lucide-react";

const RedirectSystemInfo: React.FC = () => {
  return (
    <Card className="border-blue-200 bg-blue-50">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-blue-900">
          <Info className="h-5 w-5" />
          Two-Tier Redirect System
        </CardTitle>
        <CardDescription className="text-blue-700">
          Your redirect system uses both server-side and client-side redirects for optimal performance
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Alert className="border-green-200 bg-green-50">
            <Globe className="h-4 w-4 text-green-600" />
            <AlertDescription className="text-green-800">
              <strong>Cloudflare (Server-side)</strong><br/>
              Instant redirects via `_redirects` file. No 404 flash, perfect for SEO.
              Click "Sync to Cloudflare" after adding redirects.
            </AlertDescription>
          </Alert>
          
          <Alert className="border-orange-200 bg-orange-50">
            <Database className="h-4 w-4 text-orange-600" />
            <AlertDescription className="text-orange-800">
              <strong>Database (Client-side)</strong><br/>
              Fallback for dynamic redirects and analytics tracking.
              Runs after React app loads.
            </AlertDescription>
          </Alert>
        </div>
        
        <Alert className="border-yellow-200 bg-yellow-50">
          <Zap className="h-4 w-4 text-yellow-600" />
          <AlertDescription className="text-yellow-800">
            <strong>Best Practice:</strong> Always run "Sync to Cloudflare" after creating or updating redirects 
            to ensure instant server-side redirects without 404 flashes.
          </AlertDescription>
        </Alert>
      </CardContent>
    </Card>
  );
};

export default RedirectSystemInfo; 